<template>
  <span v-if="facilities.length">
    <template v-if="useLink">
      <template v-for="facet in facets" :key="facet.slug">
        <pu-search-link
          :search-filters="searchFiltersWithoutFacet(facet.slug)"
          category="search"
        >
          {{ facet.name }}
          <img
            src="@/assets/images/close-x.svg"
            class="icon"
            width="18"
            height="18"
            alt=""
          />
        </pu-search-link>
      </template>
    </template>
    <template v-else>
      <template v-for="facet in facets" :key="facet.slug">
        <span class="search-summary-detail-facet">
          {{ facet.name }}
          <img
            src="@/assets/images/close-x.svg"
            class="icon"
            width="18"
            height="18"
            alt=""
            @click="$emit('remove-facet', facet.slug)"
          />
        </span>
      </template>
    </template>
  </span>
</template>

<script lang="ts">
import type { Facet } from '~/apps/facets/domain/facetGroups'
import type { SearchFilters } from '~/apps/search/schemas'
import { Component, Prop, Vue, toNative } from '~/utility/pu-class-decorator'
import { getCategoryFacetLinker } from '~/apps/categories/services/CategoryFacetLinker'

@Component({
  setup() {
    const searchStore = useSearchStoreSetup(usePinia())
    const facetsStore = useFacetsStoreSetup(usePinia())
    return { searchStore, facetsStore }
  },
})
class SearchSummaryBarDetailsFacets extends Vue {
  searchStore: ReturnType<typeof useSearchStoreSetup>
  facetsStore: ReturnType<typeof useFacetsStoreSetup>

  @Prop()
  searchFilters: SearchFilters

  @Prop({ default: true })
  useLink: boolean

  get facilities(): string[] {
    return this.searchFilters.facets || []
  }

  get facets(): Facet[] {
    return this.facilities
      .map((slug) => this.facetsStore.facetsBySlug(slug))
      .filter((facet): facet is Facet => facet !== undefined)
      .sort((a, b) => a.name.localeCompare(b.name))
  }

  searchFiltersWithoutFacet(slug: string) {
    const categoryIds = this.searchFilters.categoryIds || []

    // Use CategoryFacetLinker to remove the facet and potentially its parent category
    const linker = getCategoryFacetLinker()
    const result = linker.removeFacetWithCategory(
      categoryIds,
      this.facilities,
      slug,
      true, // removeParentIfEmpty
    )

    return {
      ...this.searchFilters,
      facets: result.facets,
      categoryIds: result.categoryIds,
    }
  }
}

export default toNative(SearchSummaryBarDetailsFacets)
</script>
